module.exports = __webpack_public_path__ + "img/10.7e879e52.gif";